import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { PropertyTrackTypes, Track } from "../../types";
import { Plus } from "lucide-react";
import { useState } from "react";
import AddTrackForm from "./add-track-form";
import { useReadonlyContext } from "@/modules/common/context/read-only.context";

export default function AddNewTrack({
  track,
  hasLabel = true,
}: {
  track: Track;
  hasLabel?: boolean;
}) {
  const [modalOpen, setModalOpen] = useState(false);
  const [rentalTagPromptOpen, setRentalTagPromptOpen] = useState(false);
  const canAddTrack =
    track.trackStage?.trackType.name ===
      PropertyTrackTypes.UNLOCKED_FINISHING &&
    !track.property.childPropertiesCount;

  const { readonly } = useReadonlyContext();

  const rentalTag = track.property.propertyFinishing?.rentalTag;
  const isFinishingTrack =
    track.trackStage?.trackType.name === PropertyTrackTypes.UNLOCKED_FINISHING;

  const handleButtonClick = () => {
    if (isFinishingTrack && !rentalTag) {
      setRentalTagPromptOpen(true);
    } else {
      setModalOpen(true);
    }
  };

  return canAddTrack ? (
    <>
      <Button
        disabled={readonly}
        variant="contained"
        sx={(theme) => ({
          display: "flex",
          gap: theme.nawy.spacing.xs,
          alignItems: "center",
          backgroundColor: theme.nawy.colors.semantic.layer.accent,
          ...(!hasLabel && {
            minWidth: 36,
            minHeight: 36,
            padding: 0,
          }),
        })}
        onClick={handleButtonClick}
      >
        {hasLabel ? (
          <Typography
            sx={(theme) => ({
              ...theme.nawy.typography.english.variants.body.md.semibold,
              textTransform: "none",
            })}
          >
            Add track
          </Typography>
        ) : (
          <Plus size={16} />
        )}
      </Button>

      <Dialog
        open={rentalTagPromptOpen}
        onClose={() => setRentalTagPromptOpen(false)}
      >
        <DialogTitle>Rental Tag Required</DialogTitle>
        <DialogContent>
          <Typography>
            Please select a rental tag in the Financial Info section before
            adding a linked track.
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setRentalTagPromptOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>

      <AddTrackForm
        propertyUId={track.property.uid}
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
      />
    </>
  ) : (
    <></>
  );
}
